import {memo, shapeComponent, ShapeComponent, useBreakpoint, View} from "shared/base"
import AdminContactRelationshipsSection from "components/admin/contacts/relationships-section"
import AdminShowActions from "components/admin/show-actions"
import AttributeRow from "@kaspernj/api-maker/build/bootstrap/attribute-row"
import AttributeRows from "@kaspernj/api-maker/build/bootstrap/attribute-rows"
import Button from "components/inputs/button"
import Contact from "models/contact.js"
import ContactEmail from "models/contact-email.js"
import ContactPhoneNumber from "models/contact-phone-number.js"
import ContactTypeLink from "components/contact-types/link"
import CountryLink from "components/countries/link"
import CountryStateLink from "components/country-states/link"
import Nav from "./nav"
import React from "react"
import Routes from "shared/routes"
import SchoolClassLink from "components/school-classes/link"
import SchoolLink from "components/schools/link"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"
import UserLink from "components/users/link"
import {useParams} from "@kaspernj/api-maker/build/router/route" // eslint-disable-line sort-imports
import {useAdminLayout} from "components/admin/layout" // eslint-disable-line sort-imports

export default memo(shapeComponent(class RoutesAdminContactsShow extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.contacts.show"})
    const params = useParams()
    const {contact, contactId} = useModel(Contact, {
      abilities: {
        Contact: ["destroy", "edit"]
      },
      match: {params},
      preload: ["account_manager", "contact_type", "country", "country_state", "school", "school_class", "user"],
      select: {
        Contact: ["contactPointsCount", "createdAt", "email", "id", "name", "phoneNumber", "points", "updatedAt"],
        ContactType: ["id", "name"],
        Country: ["id", "name"],
        CountryState: ["id", "name"],
        School: ["id", "name"],
        SchoolClass: ["id", "interpretedName"],
        User: ["id", "name"]
      }
    })

    this.setInstance({
      ...useBreakpoint(),
      contact,
      contactId,
      t
    })
    useAdminLayout()?.setState({actions: this.actions(), active: "contacts", headerTitle: contact?.name()})
  }

  render() {
    const {contact, t, xxlUp} = this.tt

    return (
      <View dataSet={{route: "admin/contacts/show"}}>
        {contact &&
          <>
            <Nav active="general" contact={contact} style={{marginBottom: 15}} />
            <View
              style={this.cache("contentContainerStyle", {
                alignItems: "flex-start",
                flexDirection: xxlUp ? "row" : "column",
                width: "100%"
              }, [xxlUp])}
              testID="admin-contact-show-content"
            >
              <View
                style={this.cache("attributesContainerStyle", {
                  paddingRight: xxlUp ? 30 : 0,
                  width: xxlUp ? 420 : "100%"
                }, [xxlUp])}
                testID="admin-contact-show-attributes-column"
              >
                <AttributeRows attributes={["id"]} model={contact} />
                <AttributeRow attribute="name" label={t(".name")} model={contact} />
                <AttributeRow attribute="email" label={ContactEmail.humanAttributeName("email")} model={contact} />
                <AttributeRow attribute="phoneNumber" label={ContactPhoneNumber.humanAttributeName("phoneNumber")} model={contact} />
                <AttributeRows attributes={["points", "createdAt", "updatedAt"]} model={contact} />
                <AttributeRow attribute="contactType" model={contact}>
                  {contact.contactType() &&
                    <ContactTypeLink adminLayout contactType={contact.contactType()} />
                  }
                </AttributeRow>
                <AttributeRow attribute="accountManager" model={contact}>
                  {contact.accountManager() &&
                    <UserLink adminLayout user={contact.accountManager()} />
                  }
                </AttributeRow>
                {contact.user() &&
                  <AttributeRow attribute="user" model={contact}>
                    <UserLink adminLayout user={contact.user()} />
                  </AttributeRow>
                }
                {contact.school() &&
                  <AttributeRow attribute="school" model={contact}>
                    <SchoolLink adminLayout school={contact.school()} />
                  </AttributeRow>
                }
                {contact.schoolClass() &&
                  <AttributeRow attribute="schoolClass" model={contact}>
                    <SchoolClassLink adminLayout schoolClass={contact.schoolClass()} />
                  </AttributeRow>
                }
                <AttributeRow attribute="country" model={contact}>
                  {contact.country() &&
                    <CountryLink adminLayout country={contact.country()} />
                  }
                </AttributeRow>
                <AttributeRow attribute="countryState" model={contact}>
                  {contact.countryState() &&
                    <CountryStateLink adminLayout countryState={contact.countryState()} />
                  }
                </AttributeRow>
              </View>
              <View
                style={this.cache("relationshipsColumnStyle", {
                  marginTop: xxlUp ? 0 : 20,
                  width: xxlUp ? "calc(100% - 420px)" : "100%"
                }, [xxlUp])}
                testID="admin-contact-show-relationships-column"
              >
                <AdminContactRelationshipsSection contact={contact} />
              </View>
            </View>
          </>
        }
      </View>
    )
  }

  actions() {
    const {contact, t} = this.tt

    return (
      <>
        {contact &&
          <Button
            icon="credit-card"
            label={t(".map_stripe_subscription")}
            testID="admin-contact-map-stripe-subscription-action"
            to={Routes.mapStripeSubscriptionAdminContactPath(contact.id())}
          />
        }
        <AdminShowActions model={contact} />
      </>
    )
  }
}))
